import { FETCH_POPUP_DATA, OPEN_DETAILS_POPUP, CLOSE_POPUP } from './ActionTypes';

export const openDetailsPopup = (params) => ({
  type: OPEN_DETAILS_POPUP,
  payload: { ...params }
});

export const fetchPopupData = (pagination) => ({
  type: FETCH_POPUP_DATA,
  payload: { ...pagination }
});

export const closePopup = () => ({
  type: CLOSE_POPUP
});